import { Col, Row } from "antd";
import React from "react";
import Card from "@material-ui/core/Card";
import CountrySelect from "./CountrySelect";
import styles from "./styles.less";
import WatchlistTabs from "./WatchlistTabs";

export default () => (
  <Card className={styles.watchlist}>
    <Row justify="space-between" className={styles.controls}>
      <Col sm={24} md={8}>
        <CountrySelect />
      </Col>
    </Row>
    <WatchlistTabs />
  </Card>
);
